exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 900px) {\n  #curry{\n    max-height: 400px;\n  }\n  #nba-combine {\n    max-height: 400px;\n  }\n}\n@media screen and (max-width: 700px) {\n  #curry{\n    max-height: 350px;\n  }\n  #nba-combine {\n      max-height: 350px;\n  }\n}\n@media screen and (max-width: 500px) {\n  #curry{\n    max-height: 250px;\n  }\n  #nba-combine {\n    max-height: 250px;\n  }\n}\n@media screen and (max-width: 300px) {\n  #curry{\n    max-height: 150px;\n  }\n  #nba-combine {\n    max-height: 150px;\n  }\n}\nh1, p {\n  text-align: center;\n}\n#curry {\n  width: 100%;\n  height: 450px;\n  -webkit-transition: 1.5s ease;\n  transition: 1.5s ease;\n  opacity: 1;\n}\n#nba-combine {\n   width: 100%;\n   height: 450px;\n   -webkit-transition: 1.5s ease;\n   transition: 1.5s ease;\n   opacity: 1;\n }\n.shopping:hover #curry {\n  opacity: 0.3;\n}\n.shopping:hover #nba-combine {\n  opacity: 0.3;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/mid-section/mid-section.component.css
// module id = ../../../../../src/app/mid-section/mid-section.component.css
// module chunks = main